import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import globalMessages from 'translations/messages/global-messages';

const PdfFile = ({ title = '', intl, color = '#848F9D', ...props }) => {
  return (
    <svg height="24" viewBox="0 0 15 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || intl.formatMessage(globalMessages.export_pdf)}</title>
      <path
        d="M0.684063 22.664H2.62806C2.95873 22.664 3.2414 22.712 3.47606 22.808C3.71073 22.904 3.90273 23.032 4.05206 23.192C4.20673 23.3467 4.31873 23.528 4.38806 23.736C4.46273 23.944 4.50006 24.16 4.50006 24.384C4.50006 24.672 4.4494 24.9253 4.34806 25.144C4.25206 25.3573 4.11873 25.536 3.94806 25.68C3.78273 25.824 3.59073 25.9333 3.37206 26.008C3.1534 26.0827 2.92406 26.12 2.68406 26.12H1.86006V28H0.684063V22.664ZM2.56406 25.144C2.78806 25.144 2.96406 25.0773 3.09206 24.944C3.2254 24.8053 3.29206 24.6267 3.29206 24.408C3.29206 24.184 3.2254 24.0027 3.09206 23.864C2.95873 23.72 2.78006 23.648 2.55606 23.648H1.86006V25.144H2.56406ZM5.30906 22.664H7.32506C7.73573 22.664 8.1144 22.7173 8.46106 22.824C8.81306 22.9307 9.1144 23.0933 9.36506 23.312C9.62106 23.5307 9.8184 23.8107 9.95706 24.152C10.1011 24.4933 10.1731 24.896 10.1731 25.36C10.1731 25.8027 10.1011 26.1893 9.95706 26.52C9.81306 26.8453 9.61306 27.12 9.35706 27.344C9.1064 27.5627 8.80506 27.728 8.45306 27.84C8.1064 27.9467 7.72773 28 7.31706 28H5.30906V22.664ZM7.25306 26.928C7.7864 26.928 8.19706 26.7893 8.48506 26.512C8.77306 26.2293 8.91706 25.8427 8.91706 25.352C8.91706 25.1067 8.8824 24.8853 8.81306 24.688C8.74906 24.4853 8.64773 24.3147 8.50906 24.176C8.37573 24.032 8.20506 23.9227 7.99706 23.848C7.78906 23.768 7.54106 23.728 7.25306 23.728H6.51706V26.928H7.25306ZM11.0434 22.664H14.6274V23.728H12.2514V24.936H14.0594V25.968H12.2514V28H11.0434V22.664Z"
        fill={color}
      />

      <path
        d="M8.2 1H2.6C2.17565 1 1.76869 1.16857 1.46863 1.46863C1.16857 1.76869 1 2.17565 1 2.6V15.4C1 15.8243 1.16857 16.2313 1.46863 16.5314C1.76869 16.8314 2.17565 17 2.6 17H12.2C12.6243 17 13.0313 16.8314 13.3314 16.5314C13.6314 16.2313 13.8 15.8243 13.8 15.4V6.6L8.2 1Z"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M8.20001 1V6.6H13.8"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

PdfFile.propTypes = {
  title: PropTypes.string,
  intl: PropTypes.object.isRequired,
  color: PropTypes.string,
};

export default injectIntl(PdfFile);
